<template>
  <div>
    <Loader></Loader>
    <div v-if="expenses.length > 0">
      <div
        class="page-break my-16 mx-16"
        style="page-break-after: always"
        v-for="(expense,exp) in expenses"
        :key="exp+Math.random()+Math.random()"
      >
        <header class="mb-16">
          <h1>Expense Receipt</h1>
          <address contenteditable>
            <p>{{getUserSchool.schname}}</p>
            <p>
              {{getUserSchool.sch_address}}
              <br />
              {{getUserSchool.physical_address}}
              <br />
              {{getUserSchool.pcode}}
            </p>
            <p>{{getUserSchool.sch_tel}}</p>
          </address>
          <span>
            <!--img alt="" src="{{url('images/logos/')}}{{Auth::user()->emis}}.png"><input type="file" accept="image/*"-->
          </span>
        </header>
        <br />
        <br />
        <article class="mt-12">
          <address contenteditable>
            <span>{{expense.service_providers.representative }}</span>
            <br />
            <span>{{expense.service_providers.name}}</span>
            <br />
            <span>{{expense.service_providers.address}}</span>
            <br />
            <span>{{expense.service_providers.city}}, {{expense.service_providers.code}}</span>
            <br />
            <span>{{expense.service_providers.phone}}</span>
            <br />
            <span>{{expense.service_providers.email}}</span>
          </address>

          <table class="meta">
            <tr>
              <th>
                <span contenteditable>Account #</span>
              </th>
              <td>
                <span contenteditable>180985{{expense.id}}</span>
              </td>
            </tr>
            <tr>
              <th>
                <span contenteditable>Date</span>
              </th>
              <td>
                <span contenteditable>{{ expense.entry_date }}</span>
              </td>
            </tr>
            <tr>
              <th>
                <span contenteditable>Amount Paid</span>
              </th>
              <td>
                <span id="prefix" contenteditable>{{getCurrency}}</span>
                <span>{{expense.amount}}</span>
              </td>
            </tr>
          </table>

          <br />
          <br />

          <table class="inventory">
            <thead>
              <tr>
                <th>
                  <span contenteditable>Date</span>
                </th>
                <th>
                  <span contenteditable>Description</span>
                </th>
                <th>
                  <span contenteditable>Reference #</span>
                </th>
                <th>
                  <span contenteditable>Amount Paid</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <!--a class="cut">-</a-->
                  <span contenteditable>{{expense.entry_date}}</span>
                </td>
                <td>
                  <span contenteditable>{{expense.expenses_categories.name}}</span>
                </td>
                <td>
                  <span contenteditable>180985{{expense.id}}</span>
                </td>
                <td>
                  <span contenteditable>{{getCurrency}}{{expense.amount}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <!--a class="add">+</a-->
          <table class="balance">
            <tr>
              <th>
                <span contenteditable>Total Paid</span>
              </th>
              <th>{{getCurrency}}{{ expense.amount }}</th>
            </tr>
          </table>
        </article>
        <table>
          <thead>
            <tr>
              <th style="border:none;border-bottom:2px black solid;width:30px">
                <span>Principal:</span>
              </th>
              <th style="border:none;border-bottom:2px black solid;width:30px">
                <span
                  v-if="getUserSchool.emis == '500499130' || getUserSchool.emis == '500342065'"
                >B.O.D:</span>
                <span v-else>S.G.B</span>
              </th>
              <th style="border:none;border-bottom:2px black solid;width:30px">
                <span
                  v-if="getUserSchool.emis == '500499130' || getUserSchool.emis == '500342065'"
                >E. Papenfus:</span>
                <span v-else>Finance Officer</span>
              </th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <aside>
          <h1>
            <span contenteditable>Additional Notes</span>
          </h1>
          <div contenteditable>
            <p style="width:82%;font-size: 14px;margin-right:10px;"></p>
            <br />
            <span
              style="font-size: 10px"
            >Baron IT Solutions Education Management System [076 243 9441]</span>
          </div>
        </aside>
      </div>
    </div>
    <div v-else>
      <h1 class="my-14">No Expenses Found For Selected Period Range</h1>
      <h4>
        <v-btn rounded class="ml-14" @click="goBack()" dark :color="getThemeColor">Go Back</v-btn>
      </h4>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";

export default {
  components: { Loader },
  mounted() {
        this.expenses = this.$route.params.expenses;
  },
  computed: {
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  data: () => ({
    expenses: [],
    dateFrom: new Date().toISOString().substr(0, 10),
    dateTo: new Date(new Date().getFullYear(), 11, 25)
      .toISOString()
      .substr(0, 10)
  }),
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.page-break {
  page-break-after: always;
}

/* reset */

* {
  border: 0;
  box-sizing: content-box;

  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;

  list-style: none;
  margin: 0;
  padding: 0;
  text-decoration: none;
  vertical-align: top;
}

/* content editable */

*[contenteditable] {
  border-radius: 0.25em;
  min-width: 1em;
  outline: 0;
}

*[contenteditable] {
  cursor: pointer;
}

*[contenteditable]:hover,
*[contenteditable]:focus,
td:hover *[contenteditable],
td:focus *[contenteditable],
img.hover {
  background: #def;
  box-shadow: 0 0 1em 0.5em #def;
}

span[contenteditable] {
  display: inline-block;
}

/* heading */

h1 {
  font: bold 100% sans-serif;
  letter-spacing: 0.5em;
  text-align: center;
  text-transform: uppercase;
}

/* table */

table {
  font-size: 80%;
  table-layout: fixed;
  width: 100%;
}
table {
  border-collapse: separate;
  border-spacing: 2px;
}
th,
td {
  border-width: 1px;
  padding: 0.5em;
  position: relative;
  text-align: left;
}
th,
td {
  border-radius: 0.25em;
  border-style: solid;
}
th {
  background: #eee;
  border-color: #bbb;
}
td {
  border-color: #ddd;
}

/* page */

html {
  font: 14px/1 "Open Sans", sans-serif;
  padding: 0.5in;
}
/*overflow: auto; */
html {
  background: #999;
  cursor: default;
}

body {
  box-sizing: border-box;
  height: 11in;
  margin: 0 auto;
  overflow: hidden;
  padding: 0.5in;
  width: 8.5in;
}

body {
  background: #fff;
  border-radius: 1px;
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
}

/* header */

header {
  margin: 0 0 1em;
}
header:after {
  clear: both;
  display: table;
}

header h1 {
  background: #000;
  border-radius: 0.25em;
  color: #fff;
  margin: 0 0 1em;
  padding: 0.5em 0;
}
header address {
  float: left;
  font-size: 75%;
  font-style: normal;
  line-height: 1.25;
  margin: 0 1em 0em 0;
}
header address p {
  margin: 0 0 0.25em;
}
header span,
header img {
  display: block;
  float: right;
}
header span {
  margin: 0 0 0em 0em;
  max-height: 25%;
  max-width: 60%;
  position: relative;
}
header img {
  max-height: 100%;
  max-width: 100%;
}
header input {
  cursor: pointer;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

/* article */

article,
article address,
table.meta,
table.inventory {
  margin: 0 0 1em;
}
article:after {
  clear: both;
  content: "";
  display: table;
}
article h1 {
  clip: rect(0 0 0 0);
  position: absolute;
}

article address {
  float: left;
  font-size: 100%;
  font-weight: bold;
}

/* table meta & balance */
/* Due Now row */
table.meta {
  float: right;
  width: 65%;
}

/* Totals Rows */
table.balance {
  float: right;
  width: 80%;
}

table.meta:after,
table.balance:after {
  clear: both;
}

/* table meta */
/* Due Now cells */
table.meta th {
  width: 25%;
}
table.meta td {
  width: 53%;
}

/* table items */

table.inventory {
  clear: both;
  width: 100%;
}
table.inventory th {
  font-weight: bold;
  text-align: center;
}

table.inventory td:nth-child(1) {
  width: 13%;
}
table.inventory td:nth-child(2) {
  width: 25%;
}
table.inventory td:nth-child(3) {
  text-align: right;
  width: 12%;
}
table.inventory td:nth-child(4) {
  text-align: right;
  width: 13%;
}

/* table balance */

table.balance th,
table.balance td {
  width: 50%;
}
table.balance td {
  text-align: right;
}

/* aside */

aside h1 {
  border: none;
  border-width: 0 0 1px;
  margin: 0;
}
aside h1 {
  border-color: #999;
  border-bottom-style: solid;
}

/* javascript */

.add,
.cut {
  border-width: 1px;
  display: block;
  font-size: 0.8rem;
  padding: 0.25em 0.5em;
  float: left;
  text-align: center;
  width: 0.6em;
}

.add,
.cut {
  background: #9af;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  background-image: -moz-linear-gradient(#00adee 5%, #0078a5 100%);
  background-image: -webkit-linear-gradient(#00adee 5%, #0078a5 100%);
  border-radius: 0.5em;
  border-color: #0076a3;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  text-shadow: 0 -1px 2px rgba(0, 0, 0, 0.333);
}

.add {
  margin: -2.5em 0 0;
}

.add:hover {
  background: #00adee;
}

.cut {
  opacity: 0;
  position: absolute;
  top: 0;
  left: -1.5em;
}
.cut {
  -webkit-transition: opacity 100ms ease-in;
}

tr:hover .cut {
  opacity: 1;
}

@media print {
  * {
    -webkit-print-color-adjust: exact;
  }
  html {
    background: none;
    padding: 0;
  }
  body {
    box-shadow: none;
    margin: 0;
  }
  span:empty {
    display: none;
  }
  .add,
  .cut {
    display: none;
  }
}

@page {
  margin: 0;
}
</style>